import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, filter, map, startWith } from 'rxjs';

@Component({
  selector: 'app-global-alerts',
  templateUrl: './global-alerts.component.html',
})
export class GlobalAlertsComponent implements OnInit {
  config$: Observable<GlobalAlertsConfig>;

  constructor(private router: Router, private readonly location: Location) {}

  ngOnInit(): void {
    const currentUrl$ = this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.urlAfterRedirects),
      startWith(this.location.path()),
    );

    this.config$ = currentUrl$.pipe(
      map((url) => {
        return {
          pendingActivationAlertEnabled: pendingActivationAlertEnabled(url),
          spendChangeRequestsAlertEnabled: spendChangeRequestsAlertEnabled(url),
        };
      }),
    );
  }
}

function pendingActivationAlertEnabled(url: string): boolean {
  return url === '/accounts';
}

function spendChangeRequestsAlertEnabled(url: string): boolean {
  const disabledPaths = ['/accounts', '/changerequests'];
  return disabledPaths.every((path) => !url.startsWith(path));
}

interface GlobalAlertsConfig {
  pendingActivationAlertEnabled: boolean;
  spendChangeRequestsAlertEnabled: boolean;
}
